import { createValidator, maxLength, required } from 'util/validation'

import { TerritorioMapaCamadasFormModel } from './model-territorioMapaCamadas'

export const validateTerritorioMapaCamadasForm = createValidator<TerritorioMapaCamadasFormModel>({
  nome: [required],
  categoria: [required],
  descricao: [required, maxLength(200)],
  visibilidade: [required],
})
